import React, { FC } from "react";
import {
  SectionContainer,
  ISectionContainerProps,
  Button,
  BreadcrumbBar,
  IBreadcrumbBarItem,
  UniversalAppShell,
} from "component-library";
import { dataTestIds } from "data-testids";

interface PageWrapperWithinLayoutProps extends ISectionContainerProps {
  pageHeader: string;
  subFooter?: {
    text: string;
    onClick: () => void;
  };
  breadcrumbs: IBreadcrumbBarItem[];
}

const PageWrapperWithinLayout: FC<
  React.PropsWithChildren<PageWrapperWithinLayoutProps>
> = ({ pageHeader, subFooter, children, breadcrumbs }) => {
  const containerProps: ISectionContainerProps = {
    variant: "shadowed",
  };

  return (
    //contentContainerCustomClassName="bg-color-neutral-three flex flex-col flex-1" leave it here for a while to check later
    <UniversalAppShell>
      <BreadcrumbBar items={breadcrumbs} />
      <h1 className="m-auto mt-3 w-full max-w-[1440px] px-4 text-3xl">
        {pageHeader}
      </h1>
      <div className="m-auto w-full max-w-[1440px] flex-1 py-5 md:px-4">
        <div className="g-col-lg-12">
          <SectionContainer {...containerProps}>
            <div className="relative px-4 md:px-4">{children}</div>
          </SectionContainer>
        </div>
      </div>
      {subFooter && (
        <div className="high-[50px] sticky bottom-0 flex justify-center rounded-t-lg bg-white px-[15px] py-[5px] shadow-[0px_-8px_10px_0px_#1c1c1c33] md:justify-end">
          <Button
            type="secondary"
            className="max-w-[330px]"
            text={subFooter.text}
            onClick={subFooter.onClick}
            data-testid={
              dataTestIds.userAccountApp["Pagewrapper.Footer.closeButton"]
            }
          />
        </div>
      )}
    </UniversalAppShell>
  );
};

export default PageWrapperWithinLayout;
